import { ControllerRenderProps } from "react-hook-form";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PlatformUnits } from "@/generated-api/models/PlatformUnits";

export const UnitsLabelMap: Record<PlatformUnits, string> = {
  [PlatformUnits.METRIC]: "cm/km (Metric)",
  [PlatformUnits.US]: "ft/miles (Imperial)",
};

export default function PlatformUnitsSelector({
  formField,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formField: ControllerRenderProps<any>;
}) {
  return (
    <Select
      onValueChange={formField.onChange}
      value={formField.value}
      defaultValue={PlatformUnits.METRIC}
    >
      <SelectTrigger className="focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0">
        <SelectValue placeholder="Select units" />
      </SelectTrigger>
      <SelectContent className="dark">
        <SelectGroup>
          {Object.values(PlatformUnits).map((value) => (
            <SelectItem key={value} value={value}>
              {UnitsLabelMap[value]}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
